export default __webpack_public_path__ + "static/media/ads-web-1.b9f4d941.gif";